import React, { useState, useEffect } from 'react';

const Toast = ({ message, type, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // 컴포넌트가 마운트되면 툴팁을 보이게 합니다.
        setIsVisible(true);

        // 5초 후에 툴팁을 숨깁니다.
        const timer = setTimeout(() => {
            setIsVisible(false);
            // 애니메이션이 끝난 후 완전히 제거하기 위해 onClose 함수 호출
            setTimeout(() => {
                if (onClose) onClose();
            }, 500); // CSS transition 시간과 맞춰줍니다.
        }, 5000);

        // 컴포넌트가 언마운트될 때 타이머를 정리합니다.
        return () => clearTimeout(timer);
    }, [onClose]);

    // 툴팁의 동적 스타일 (visible 상태에 따라 transform 속성 변경)
    const toastStyle = {
        transform: `translateX(-50%) translateY(${isVisible ? '0' : '-100px'})`,
        opacity: isVisible ? 1 : 0,
        backgroundColor: type === 'error' ? '#F2372D' : 'blue',
    };

    return (
        <div style={toastStyle} className="toast-container">
            <p>{message}</p>
            <style jsx>{`
                .toast-container {
                    position: fixed;
                    top: 20px;
                    left: 50%;
                    color: white;
                    padding: 15px 25px;
                    border-radius: 8px;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                    z-index: 1000;
                    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
                }

                .toast-container p {
                    margin: 0;
                    font-size: 16px;
                    color: white;
                    font-weight:600;
                }
            `}</style>
        </div>
    );
};

export default Toast;